import { finalize } from 'rxjs/operators';
import { AlertService } from '../../shared/services/alert.service';
import { FileSaverService } from '../../shared/services/file-saver.service';
import { LoadingWrapperService } from '../../shared/services/loading-wrapper.service';
import { ReportingService } from '../services/reporting.service';
import { CapacityReportFormGroup } from './capacity-report-form.formgroup';
var CapacityReportFormComponent = /** @class */ (function () {
    function CapacityReportFormComponent(loadingService, alertService, reportingService, reportWriterService) {
        this.loadingService = loadingService;
        this.alertService = alertService;
        this.reportingService = reportingService;
        this.reportWriterService = reportWriterService;
        this.rootForm = new CapacityReportFormGroup();
    }
    Object.defineProperty(CapacityReportFormComponent.prototype, "plantingDateRangeFormControl", {
        get: function () {
            return this.rootForm.plantingDateRangeFormControl;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CapacityReportFormComponent.prototype, "plantingDateRange", {
        get: function () {
            return this.rootForm.plantingDateRange;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CapacityReportFormComponent.prototype, "plantingStartDate", {
        get: function () {
            return this.rootForm.plantingStartDate;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CapacityReportFormComponent.prototype, "plantingEndDate", {
        get: function () {
            return this.rootForm.plantingEndDate;
        },
        enumerable: true,
        configurable: true
    });
    CapacityReportFormComponent.prototype.generateReport = function () {
        var _this = this;
        this.loadingService.setMessage('Generating capacity report...');
        this.reportingService.getCapacityReport({
            plantingStartDate: this.plantingStartDate,
            plantingEndDate: this.plantingEndDate,
        })
            .pipe(finalize(function () { return _this.loadingService.clearMessage(); }))
            .subscribe(function (file) { return _this.reportWriterService.save(file); }, function (_error) { return _this.alertService.error('Error generating capacity report.'); });
    };
    return CapacityReportFormComponent;
}());
export { CapacityReportFormComponent };



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/reporting/capacity-report-form/capacity-report-form.component.ts.pre-build-optimizer.js